// extracted by mini-css-extract-plugin
export default {"globalFilter":"GlobalFilter-module__globalFilter___zXnWH","searchIcon":"GlobalFilter-module__searchIcon___xcmIA","clearIcon":"GlobalFilter-module__clearIcon___NlrYU"};